import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import Loader from '@/components/common/Loader';
import Error from '@/components/common/Error';
import { ScrollArea } from '@/components/ui/scroll-area';

import { useActivitiesV2 } from '@/data/activity';

import OfferingInfo from './components/viewOfferingDialog/OfferingInfo';

const ViewOfferingDialog = ({ offeringId, onClose, onBook }) => {
  const activities = useActivitiesV2();

  const loadingComponent = (
    <div className="h-[175px]">
      <Loader />
    </div>
  );

  let content = <OfferingInfo offeringId={offeringId} />;

  if (activities.isLoading && !activities.data) {
    content = loadingComponent;
  }
  if (activities.error) {
    content = <Error error="There was an error loading the activities" />;
  }

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-[90vw] px-2 rounded-lg">
        <DialogHeader className="mb-4">
          <DialogTitle>Offering Info</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[500px]">
          <div className="p-2">{content}</div>
        </ScrollArea>
        <DialogFooter>
          <Button onClick={onBook}>Book</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ViewOfferingDialog;
